/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CheckSquareIcon16Light } from './CheckSquareIcon16Light';
import { CheckSquareIcon16Regular } from './CheckSquareIcon16Regular';
import { CheckSquareIcon16Solid } from './CheckSquareIcon16Solid';
import { CheckSquareIcon20Light } from './CheckSquareIcon20Light';
import { CheckSquareIcon20Regular } from './CheckSquareIcon20Regular';
import { CheckSquareIcon20Solid } from './CheckSquareIcon20Solid';
import { CheckSquareIcon24Regular } from './CheckSquareIcon24Regular';
import { CheckSquareIcon24Solid } from './CheckSquareIcon24Solid';
import { CheckSquareIcon32Regular } from './CheckSquareIcon32Regular';
import { CheckSquareIcon64Regular } from './CheckSquareIcon64Regular';
var sizes = {
    16: {
        light: CheckSquareIcon16Light,
        regular: CheckSquareIcon16Regular,
        solid: CheckSquareIcon16Solid,
    },
    20: {
        light: CheckSquareIcon20Light,
        regular: CheckSquareIcon20Regular,
        solid: CheckSquareIcon20Solid,
    },
    24: {
        regular: CheckSquareIcon24Regular,
        solid: CheckSquareIcon24Solid,
    },
    32: {
        regular: CheckSquareIcon32Regular,
    },
    64: {
        regular: CheckSquareIcon64Regular,
    },
};
export var CheckSquareIcon = forwardRef('CheckSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
